import GenericVModel from '@components/mixins/genericVModel'

export default {
  name: 'EditBlockSelect',
  mixins: [GenericVModel],
  props: {
    /**
     * The options for the select
     * @type {Array} array of objects [{label: 'Next page', value: 'next'}, ...] or just an array ['val1', 'val2', ...]
     */
    options: {
      required: true,
      type: Array,
    },
    /**
     * The array is values only, use the values for both text and values
     */
    valuesOnly: {
      required: false,
      type: Boolean,
      default: false,
    },
    /**
     * Is this a fontPicker
     */
    fontSelect: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getValue(option) {
      if (this.valuesOnly) {
        return option
      }
      return option.value
    },
    getLabel(option) {
      if (this.valuesOnly) {
        return option
      }
      return option.label
    },
    getStyles(option) {
      if (this.fontSelect) {
        return { fontFamily: option }
      }
      return ''
    },
    getDisabled(option) {
      if (this.valuesOnly) {
        return false
      }

      return option.disabled ? option.disabled : false
    },
  },
}
